import { render, staticRenderFns } from "./orderMigrateOrderLinesDialog.vue?vue&type=template&id=21e2d574&scoped=true"
import script from "./orderMigrateOrderLinesDialog.vue?vue&type=script&lang=ts"
export * from "./orderMigrateOrderLinesDialog.vue?vue&type=script&lang=ts"
import style0 from "./orderMigrateOrderLinesDialog.vue?vue&type=style&index=0&id=21e2d574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e2d574",
  null
  
)

export default component.exports